import { render, staticRenderFns } from "./slices.vue?vue&type=template&id=14610a01&scoped=true&"
import script from "./slices.vue?vue&type=script&lang=js&"
export * from "./slices.vue?vue&type=script&lang=js&"
import style0 from "./slices.vue?vue&type=style&index=0&id=14610a01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14610a01",
  null
  
)

export default component.exports